import {
  UI_EVENTS,
  CART_EVENTS,
  dispatchCartEvent,
  onCartEvent,
} from "./cart-events.js";

import { formatMoney } from "./utils.js";

const SELECTORS = {
  cartCount: "[data-ci-count]",
  iconWrapper: "[data-ci-icon-wrapper]",
};

class CartIcon extends HTMLElement {
  #callbackFunctions = [];

  constructor() {
    super();
    this.refreshCartValueAndCount = this.refreshCartValueAndCount.bind(this);
    this.onItemAdded = this.onItemAdded.bind(this);
  }

  connectedCallback() {
    this.#bindElements();
    this.#getDataAttributes();
    this.#bindEvents();
  }

  #bindElements() {
    this.cartCount = this.querySelector(SELECTORS.cartCount);
    this.iconWrapper = this.querySelector(SELECTORS.iconWrapper);
    const amountRef = this.dataset.ciAmountRef;
    this.cartAmount = amountRef ? document.getElementById(amountRef) : null;
  }

  #getDataAttributes() {
    this.action = this.dataset.ciClickAction;
    this.analytics = this.dataset.ciAnalytics;
  }

  #bindEvents() {
    this.#callbackFunctions.push(
      onCartEvent(CART_EVENTS.UPDATED, this.refreshCartValueAndCount),
    );
    this.#callbackFunctions.push(
      onCartEvent(CART_EVENTS.ITEM_ADDED, this.onItemAdded),
    );

    if (this.action === "open-cart-drawer") {
      this.addEventListener("click", this.#onCartDrawerOpen);
    } else if (this.action === "open-cart-page") {
      this.addEventListener("click", this.#redirectToCart);
    }

    if (this.cartCount) {
      this.cartCount.addEventListener("animationend", () => {
        this.cartCount.classList.remove("is-animating");
      });
    }
  }

  #redirectToCart(event) {
    event.preventDefault();
    window.location = `${window.ThemeRoutes.cart}`;
  }

  #onCartDrawerOpen(event) {
    event.preventDefault();
    dispatchCartEvent(UI_EVENTS.CART_OPEN_REQUESTED, {
      source: "cart-icon",
      analytics: this.analytics,
    });
  }

  refreshCartValueAndCount({ cart }) {
    if (!cart) {
      return;
    }

    if (this.cartCount) {
      this.cartCount.innerText = cart.item_count;
      if (cart.item_count > 0) {
        this.cartCount.removeAttribute("hidden");
      } else {
        this.cartCount.setAttribute("hidden", "");
      }
      this.cartCount.classList.add("is-animating");
    }
    if (this.cartAmount) {
      this.cartAmount.innerText = formatMoney(cart.total_price);
    }
  }

  onItemAdded() {
    this.#pulseIcon();
  }

  #pulseIcon() {
    const target = this.iconWrapper || this;
    target.classList.remove("is-pulsing");
    void target.offsetWidth;
    target.classList.add("is-pulsing");
    target.addEventListener(
      "animationend",
      () => target.classList.remove("is-pulsing"),
      { once: true },
    );
  }

  disconnectedCallback() {
    this.#cleanup();
  }

  #cleanup() {
    this.#callbackFunctions.forEach((fn) => fn());
    this.#callbackFunctions = [];
  }
}

if (!customElements.get("cart-icon")) {
  customElements.define("cart-icon", CartIcon);
}
